import React from 'react';
import styled from 'styled-components';
import { FormatQuote } from '@material-ui/icons';

function ReviewItem({ quote, author }) {
  return (
    <RevivewItemStyled>
      <div className="quote-container">
        <FormatQuote className="rot-180" />
        {quote}

        <FormatQuote />
      </div>
      <div className="author">
        <p className="author-name">- {author}</p>
      </div>
    </RevivewItemStyled>
  );
}

const RevivewItemStyled = styled.div`
  padding: 2rem 1rem;
  border-left: 6px solid var(--border-color);
  background-color: var(--background-dark-grey);
  position: relative;
  border-radius: 50px;
  width: 100%;
  transition: all 0.4s ease-in-out;
  &:not(:first-child) {
  }
  &::after {
    content: '';
    position: absolute;
    left: 2rem;
    border-width: 0.8rem;
    top: 100%;
    border-style: solid;
    border-color: var(--background-dark-grey) transparent transparent var(--background-dark-grey);
  }
  &:hover {
    border-left: 8px solid var(--primary-color);
  }

  .quote-container {
    padding: 1rem 0;
    font-style: italic;
    line-height: 30px;
    .rot-180 {
      transform: rotate(180deg);
    }
  }
  .author {
    display: flex;
    justify-content: end;
    align-items: center;

    img {
      border-radius: 50px;
      width: 40px;
      height: 40px;
    }
    .author-name {
      padding: 1rem;
      font-style: italic;
    }
  }
  svg {
    font-size: 1rem;
  }
`;

export default ReviewItem;
